/** Locale routing: French at root, English under /en. */

import landingPagesMeta from '../config/landing-pages-meta.json';

export const DEFAULT_LOCALE = 'fr';
export const EN_LOCALE = 'en';
export const SUPPORTED_LOCALES = [DEFAULT_LOCALE, EN_LOCALE];

const LANDING_PAGE_PATHS = landingPagesMeta.pages.map((entry) => entry.path);

const PUBLIC_LOCALIZED_PREFIXES = [
  '/help',
  '/on-air',
  '/signup',
  '/login',
  '/terms',
  '/privacy',
  ...LANDING_PAGE_PATHS,
];

export function getLocaleFromPathname(pathname) {
  if (pathname === '/en' || pathname.startsWith('/en/')) {
    return EN_LOCALE;
  }
  return DEFAULT_LOCALE;
}

export function stripLocalePrefix(pathname) {
  if (pathname === '/en') return '/';
  if (pathname.startsWith('/en/')) {
    const rest = pathname.slice(3);
    return rest.startsWith('/') ? rest : `/${rest}`;
  }
  return pathname;
}

export function localizePath(path, locale = DEFAULT_LOCALE) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const bare = stripLocalePrefix(normalized);

  if (locale === EN_LOCALE) {
    return bare === '/' ? '/en' : `/en${bare}`;
  }

  return bare;
}

export function isPublicLocalizedPath(pathname) {
  const bare = stripLocalePrefix(pathname);
  if (bare === '/') return true;
  return PUBLIC_LOCALIZED_PREFIXES.some(
    (prefix) => bare === prefix || bare.startsWith(`${prefix}/`)
  );
}

export function getHreflangUrls(path) {
  const baseUrl = (process.env.REACT_APP_PUBLIC_URL || 'https://live.gniarkgniark.fr').replace(
    /\/$/,
    ''
  );
  const bare = stripLocalePrefix(path.startsWith('/') ? path : `/${path}`);
  const frUrl = bare === '/' ? `${baseUrl}/` : `${baseUrl}${bare}`;
  const enUrl = bare === '/' ? `${baseUrl}/en` : `${baseUrl}/en${bare}`;

  return {
    fr: frUrl,
    en: enUrl,
    xDefault: frUrl,
  };
}
